import PrimaryButton from 'components/primaryButton';
import { ReactComponent as NoBlogIcon } from 'assets/icons/noBlogicon.svg';

import Usegetemployeeblogs from '../hooks/usegetemployeeblogdata';
import EmployeeBlogList from './employeeblogsList';
import { useState } from 'react';
import AddNewStroryEmployeeModal from './addnewBlogemployee';

const MyStories = ({ searchText, filterYear }) => {
  const employeeBlogData = Usegetemployeeblogs({
    BlogId: '',
    isDeleted: 'False',
    isDraft: 'False',
    searchText: searchText,
    filterYear: filterYear,
  });
  const [newStoryModal, setNewStoryModal] = useState(false);
  // eslint-disable-next-line
  const extractContent = (s) => {
    const span = document.createElement('span');
    span.innerHTML = s;
    return span.textContent || span.innerText;
  };
  return (
    <>
      {employeeBlogData?.data?.data.length === 0 ? (
        <div className='bg-[#fff] min-h-[72vh] rounded-xl shadow-2xl p-4 flex justify-center items-center flex-col'>
          <NoBlogIcon />
          <p className='text-[#535353] mt-4 text-base'>
            Seems like you have not written any stories yet
          </p>
          <button className='mt-4' onClick={() => setNewStoryModal(true)}>
            <PrimaryButton>Add a story</PrimaryButton>
          </button>
        </div>
      ) : (
        <div className='bg-[#fff] min-h-[72vh] rounded-xl shadow-2xl p-5 w-full'>
          <div className=''>
            {employeeBlogData?.data?.data.map((eachBlog) => (
              <div className='' key={eachBlog.id}>
                <EmployeeBlogList blogData={eachBlog} />
              </div>
            ))}
          </div>
        </div>
      )}
      <AddNewStroryEmployeeModal
        newStoryModal={newStoryModal}
        setNewStoryModal={setNewStoryModal}
      />
    </>
  );
};

export default MyStories;
